import kfetch from '@kareo/kfetch';
import rollbar from 'shared-assets/src/errors/errors';

/**
 * @constant
 * @type {string}
 */
export const TIERED_PRICING_ENDPOINT_URL =
  '/common-ui/api/customer/is-tiered-pricing';
const TEBRA_PACKAGE_ENDPOINT_URL = '/common-ui/api/customer/is-tebra-package';

const TIERED_PRICING_KEY = 'tiered-pricing-';
const TEBRA_PACKAGE_KEY = 'tebra-package-';

const TieredPricing = {
  /**
   * Checks if customer is part of Tiered package pricing (aka GBB)
   * Warning: This function do not throw an exception when the endpoint fails, instead return 0.
   * @warning :
   * @async
   * @function isTieredPricing
   * @param {Number} editionSetId - (optional) The id that identifies the customer edition set and the tiered pricing
   * @return {boolean} - Returns if the customer uses a tiered pricing
   */
  isTieredPricing: async editionSetId => {
    return TieredPricing.checkByKeyAndEdition(
      editionSetId,
      TIERED_PRICING_KEY + editionSetId,
      TIERED_PRICING_ENDPOINT_URL,
    );
  },
  /**
   * Checks if customer is part of Tebra Package pricing (aka Tebra 1.5).
   * Warning: This function do not throw an exception when the endpoint fails, instead return 0.
   * @warning :
   * @async
   * @function isTebraPackage
   * @param {Number} editionSetId - (optional) The id that identifies the customer edition set and the tiered pricing
   * @return {boolean} - Returns if the customer uses a tiered pricing
   */
  isTebraPackage: async editionSetId => {
    return TieredPricing.checkByKeyAndEdition(
      editionSetId,
      TEBRA_PACKAGE_KEY + editionSetId,
      TEBRA_PACKAGE_ENDPOINT_URL,
    );
  },
  clean: () => {
    TieredPricing.removeItemsByPattern(TIERED_PRICING_KEY);
    TieredPricing.removeItemsByPattern(TEBRA_PACKAGE_KEY);
  },
  checkByKeyAndEdition: async (editionSetId, cacheKey, endpointUrl) => {
    try {
      let cacheValue = sessionStorage.getItem(cacheKey);

      // If we already has the value then return that value
      if (cacheValue !== null && cacheValue !== 'undefined') {
        return JSON.parse(cacheValue);
      }

      // If we don't have the value then call to common-ui to get the value
      const params = new URLSearchParams();
      if (!!editionSetId) {
        params.append('editionSetId', editionSetId);
      }
      const res = await kfetch(`${endpointUrl}?${params.toString()}`);
      // Store the value in the session storage.
      if (res !== null) {
        sessionStorage.setItem(cacheKey, res);
        return res;
      }
      // If the response is not correct then return false
      return false;
    } catch (err) {
      rollbar.error(err);
      // In case we find an error then it should behave as GBB is disabled
      return false;
    }
  },
  removeItemsByPattern: async pattern => {
    Object.keys(sessionStorage)
      .filter(function (k) {
        return new RegExp(pattern).test(k);
      })
      .forEach(function (k) {
        sessionStorage.removeItem(k);
      });
  },
};

export default TieredPricing;
